import React from "react";
import { Box, Button, Divider, Typography } from "@material-ui/core";

import QuyChe from "../../../components/QCV/QuyChe";
import { QCV2026_LINKS } from "../../../constants/qcv2026.config";

// Trang riêng "Quy chế xét thưởng" (điều hướng từ nút Chi tiết ở trang Giới thiệu).
export default function QuyChePage() {
  return (
    <Box paddingY={3} className="formal-text">
      <Typography
        variant="h4"
        style={{ textAlign: "center", fontFamily: "WorkSans-ExtraBold" }}
      >
        <strong>QUY CHẾ XÉT THƯỞNG</strong>
      </Typography>
      <Typography variant="h6" style={{ textAlign: "center", color: "#55626a" }}>
        <i>
          (Theo Quy chế Giải thưởng ban hành theo Quyết định số 1299-QĐ/TWĐTN-KHCN ngày 25/5/2026 của Ban Bí thư Trung ương Đoàn)
        </i>
      </Typography>

      {QCV2026_LINKS.quyetDinhQuyChe ? (
        <Box textAlign="center" marginTop={2}>
          <Button
            color="secondary"
            variant="contained"
            href={QCV2026_LINKS.quyetDinhQuyChe}
            target="_blank"
            rel="noreferrer"
          >
            Xem toàn bộ Quyết định kèm Quy chế Giải thưởng (PDF)
          </Button>
        </Box>
      ) : null}

      <Divider
        style={{
          width: 64,
          height: 4,
          backgroundColor: "#ee6064",
          margin: "24px auto",
        }}
      />

      <QuyChe />
    </Box>
  );
}
